import { Route } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { OperationsGuard } from "../guards/operations.guard";

export const TeacherPipelineRoutes: Route[] = [
  {
    path: "teacher-pipeline",
    loadComponent: () =>
      import("../../Feature/teacher-pipeline/pages/pipeline/teacher-pipeline.component").then(
        (mod) => mod.TeacherPipelineComponent
      ),
    pathMatch: "full",
    canActivate: [AuthGuard, OperationsGuard],
  },
];
